import { Duration, LocalDate, ZonedDateTime } from '@js-joda/core';

import { Timesheet } from '#/shared/types/Timesheet';
import { ShiftEntryApi, TimesheetApiEntity } from '#/shared/types/TimesheetApiModal';
/**
 * Maps `TimesheetApiEntity` data to the app `Timesheet` model.
 * @param {TimesheetApiEntity} source The TimesheetApiEntity object
 */
export const mapTimesheetApiEntityToTimesheet = (source: TimesheetApiEntity): Timesheet => ({
  id: source.data.id,
  timesheetId: source.data.timesheetId,
  weekEnding: LocalDate.parse(source.data.weekEnding),
  doctorName: source.data.doctorName,
  hospitalName: source.data.hospitalName,
  additionalInfo: source.data.additionalInformation,
  department: source.data.department,
  clientId: source.data.clientId,
  shifts: source.data.shifts.map((shift: ShiftEntryApi) => ({
    startAt: LocalDate.parse(shift.start_at),
    timeEntries: shift.time_entries.map(entry => ({
      startAt: ZonedDateTime.parse(entry.start_at),
      endAt: ZonedDateTime.parse(entry.end_at),
      shiftType: entry.shift_type,
      break: entry.break ? Duration.parse(entry.break) : undefined,
      total: entry.total ? Duration.parse(entry.total) : undefined,
      notes: entry.notes,
      paidBreakRequest: entry.paid_break_request
        ? {
            break: Duration.parse(entry.paid_break_request.break),
            reason: entry.paid_break_request.reason,
            notes: entry.paid_break_request.notes,
            approver_decision: entry.paid_break_request.approver_decision,
            approver_notes: entry.paid_break_request.approver_notes,
          }
        : undefined,
    })),
  })),
  verifiedBy: source.data.verifiedBy
    ? {
        name: source.data.verifiedBy.name,
        role: source.data.verifiedBy.role,
        department: source.data.verifiedBy.department,
        notes: source.data.verifiedBy.notes,
        verifiedAt: ZonedDateTime.parse(source.data.verifiedBy.verified_at),
      }
    : undefined,
});
